import { OnInit, Component } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";

// import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-weekly-view',
    templateUrl: './weekly-view.component.html',
    styleUrls: ['./weekly-view.component.scss']
})
export class WeeklyViewComponent implements OnInit {
    settingssuppliercode: { singleSelection: boolean; text: string; selectAllText: string;
         unSelectAllText: string; enableSearchFilter: boolean;
         itemsShowLimit: number;
         idField: string;
        textField: string; };
    rangeDates: Date[];
    suppliercodes: any;
    noofpartData: { labels: string[]; datasets: { data: number[]; backgroundColor: string[]; hoverBackgroundColor: string[]; }[]; };
    weightData: { labels: string[]; datasets: { data: number[]; backgroundColor: string[]; hoverBackgroundColor: string[]; }[]; };
    volumeData: { labels: string[]; datasets: { data: number[]; backgroundColor: string[]; hoverBackgroundColor: string[]; }[]; };
    supplierCodeList: { "id": number; "itemName": string; }[];
    public piechartoptions: any = {
        responsive: false,
        maintainAspectRatio: false
    };
    constructor(private translate: TranslateService) { }

    ngOnInit() {
        this.settingssuppliercode = {
            singleSelection: false,
            text: "Select Supplier Code",
            selectAllText: this.translate.instant('Select All'),
            unSelectAllText: 'UnSelect All',
            enableSearchFilter: true,
            // classes: "custom-class",
            itemsShowLimit: 4,
            idField: 'id',
            textField: 'itemName'
        };
        this.volumeData = {
            labels: ['K1', 'K2', 'CC Yokohama'],
            datasets: [
                {
                    data: [100, 225, 90],
                    backgroundColor: [
                        "#13135d",
                        "#DFDCDB",
                        "#9BC6F3"
                    ],
                    hoverBackgroundColor: [
                        "#13135e",
                        "#DFDCDB",
                        "#9BC6F3"
                    ]
                }]
        };
        this.weightData = {
            labels: ['K1', 'K2', 'CC Yokohama'],
            datasets: [
                {
                    data: [100, 70, 200],
                    backgroundColor: [
                        "#13135d",
                        "#DFDCDB",
                        "#9BC6F3"
                    ],
                    hoverBackgroundColor: [
                        "#13135e",
                        "#DFDCDB",
                        "#9BC6F3"
                    ]
                }]
        };
        this.noofpartData = {
            labels: ['K1', 'K2', 'CC Yokohama'],
            datasets: [
                {
                    data: [120, 30, 80],
                    backgroundColor: [
                        "#13135d",
                        "#DFDCDB",
                        "#9BC6F3"
                    ],
                    hoverBackgroundColor: [
                        "#13135e",
                        "#DFDCDB",
                        "#9BC6F3"
                    ]
                }]
        };
        this.supplierCodeList = [
            { "id": 1, "itemName": "S01" },
            { "id": 2, "itemName": "S02" },
            { "id": 3, "itemName": "D01" },
            { "id": 4, "itemName": "D02" },
            { "id": 5, "itemName": "D03" },
            { "id": 6, "itemName": "E01" },
            { "id": 7, "itemName": "E02" },
            { "id": 8, "itemName": "Y13" },
            { "id": 9, "itemName": "Y10" },
            { "id": 10, "itemName": "RY01" }
        ];

    }
    onDeSelectSupplierCode(yes: any) { }
    onSelectAllSupplierCode(yes: any) { }
    DeSelectAllSupplierCode(yes: any) { }
    onSingleSelectSupplierCode(yes: any) { }
    updateweeklyData() { }
}
